import layout from '@/layout/Layout'
import layoutBlank from "@/layout/LayoutBlank"

// ------------------------------权限配置----------begin--------------------------
import role from '@/pcpage/ptooa/permission/role'
import roleload from '@/pcpage/ptooa/permission/roleload'
import modutree from '@/pcpage/ptooa/permission/modutree'
// ------------------------------权限配置----------end----------------------------

let router = [
    {
      path: '/layout',
      redirect: "/layout/home",
      component: layout,
      children: [
        {
          path: 'role',
          component: role,
          meta: { title: 'MSSPTO' }
        },
      ]
    },
    {
      path: '/roleload',
      component: roleload,
      meta: { title: 'MSSPTO' }
    },
    // 无菜单页面布局
    {
      path: '/layoutBlank',
      component: layoutBlank,
      children: [{
          path: 'modutree',
          component: modutree,
          meta: { title: 'MSSPTO' }
      }]
  },
]
export default router;


// WEBPACK FOOTER //
// ./src/router/role_router.js